export const jsonFilterData = {
    type: {
      name: 'Type',
      type: 'ItemSelection',
      both: true,
      data: ['1 Bedroom', '1 Bedroom + Den', '2 Bedroom', '2 Bedroom + Den', '3 Bedroom', '3 Bedroom + Den'],
      selected: []
    },
    area: {
      name: 'Area (sq.ft.)',
      type: 'RangeSelection',
      data: [400, 1500],
      rangeMargin: 65,
      selected: []
    },
    bathroom: {
      name: 'Bathroom',
      type: 'ItemSelection',
      data: [1, 2, 3, 4],
      both: true,
      selected: []
    },
    orientation: {
      name: 'Orientation',
      type: 'ItemSelection',
      both: true,
      data: ['S', 'W', 'N', 'E'],
      selected: []
    },
    balcony: {
      name: 'Balcony',
      type: 'ItemSelection',
      data: ['Included', 'Not Included'],
      both: false,
      selected: []
    },  
    floor: {
      name: 'Floor',
      type: 'RangeSelection',
      data: [1, 40],
      rangeMargin: 1,
      selected: [1, 40]
    },
    position: {
      name: 'Corner units',
      type: 'ItemRadio',
      both: true,
      data: 'Corner',
      selected: false
    },
  }